import { render, staticRenderFns } from "./MenuBubble.vue?vue&type=template&id=4eea10f5&scoped=true&"
import script from "./MenuBubble.vue?vue&type=script&lang=js&"
export * from "./MenuBubble.vue?vue&type=script&lang=js&"
import style0 from "./MenuBubble.vue?vue&type=style&index=0&id=4eea10f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea10f5",
  null
  
)

export default component.exports